import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TagsListComponent } from './tags-list/tags-list.component';
import { TagsCreateComponent } from './tags-create/tags-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: TagsListComponent,
        data: {
          title: "Tags List",
          breadcrumb: "Tags List"
        }
      },
      {
        path: 'create',
        component: TagsCreateComponent,
        data: {
          title: "Create Tags",
          breadcrumb: "Create Tags"
        }
      },
      {
        path: 'edit/:id',
        component: TagsCreateComponent,
        data: {
          title: "Edit Tags",
          breadcrumb: "Edit Tags"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class TagsRoutingModule { }
